import script from "./sf-markdown-document-link-picker.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-markdown-document-link-picker.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__